import React, { useContext } from 'react'
import { ISelectOption } from '../../model/interfaces/ISelectOption'
import { FieldProps } from 'formik'
import { FormLabel } from '../FormLabel'
import { cn } from '../../lib/utils'
import { IsDisabledContext } from '../../model/context/IsDisabledContext'

interface Props extends FieldProps {
  options: ISelectOption[]
  label?: string
  disabled?: boolean
}

const RadioInput: React.FC<Props> = (props) => {
  const disabled = useContext(IsDisabledContext) || props.disabled || false

  return (
    <fieldset>
      <FormLabel>{props.label}</FormLabel>
      <legend className="sr-only">{props.label}</legend>
      <div className="space-y-2 mt-3">
        {props.options.map((option) => (
          <div key={option.value} className="relative flex items-start">
            <div className="flex h-6 items-center">
              <input
                id={`${props.field.name}-${option.value}`}
                aria-describedby={`${option.value}-description`}
                name={props.field.name}
                type="radio"
                checked={option.value === props.field.value}
                className={cn(
                  'h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600',
                  disabled ? 'cursor-not-allowed text-gray-500' : 'cursor-pointer',
                )}
                onClick={() => props.form.setFieldValue(props.field.name, option.value)}
                disabled={disabled}
              />
            </div>
            <div className="ml-3 text-sm leading-6">
              <label
                htmlFor={`${props.field.name}-${option.value}`}
                className="font-medium text-gray-900"
              >
                {option.label}
              </label>{' '}
              <span id={`${option.value}-description`} className="text-gray-500">
                {option.description && <>{option.description}</>}
              </span>
            </div>
          </div>
        ))}
      </div>
    </fieldset>
  )
}

export default RadioInput
